<template>
  <div class="competition">
  	<!-- <el-radio-group v-model="tabPosition">
  	    <el-radio-button v-for="item in position" :key="item.id" :label="item.id">{{item.label}}</el-radio-button>
  	</el-radio-group> -->
  </div>	
</template>
<script>
import eventBus from '@/utils/eventBus'
export default {
    name:"Competition",
	data() {
		return {
			position:[
				{label:'本届',id:202601},
				{label:'上届',id:202402}
			],
			tabPosition:202601
		}
	},
	watch:{
		tabPosition(id){
			console.log(id)
			eventBus.$emit('changeCompetition',id)
		}
	}
}
</script>
<style scoped>
.competition {
	margin-left: 10px;
}
</style>